// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const LogLevelEnum = {
  NUMBER_10: 10,
  NUMBER_20: 20,
  NUMBER_30: 30,
  NUMBER_40: 40,
  NUMBER_50: 50,
} as const;
export type LogLevelEnum = (typeof LogLevelEnum)[keyof typeof LogLevelEnum];

export function instanceOfLogLevelEnum(value: any): boolean {
  for (const key in LogLevelEnum) {
    if (Object.prototype.hasOwnProperty.call(LogLevelEnum, key)) {
      if (LogLevelEnum[key as keyof typeof LogLevelEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function LogLevelEnumFromJSON(json: any): LogLevelEnum {
  return LogLevelEnumFromJSONTyped(json, false);
}

export function LogLevelEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogLevelEnum {
  return json as LogLevelEnum;
}

export function LogLevelEnumToJSON(value?: LogLevelEnum | null): any {
  return value as any;
}

export function LogLevelEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): LogLevelEnum {
  return value as LogLevelEnum;
}
